import { checkGate, isStatsigInitialized } from '@eventbrite/statsig';
import React from 'react';
import {
    ConversionBar,
    ConversionBarComponentProps,
} from './ConversionBar/ConversionBar';
import './ConversionBarContainer.scss';
import { TicketSelectionIframe } from './TicketSelectionIframe/TicketSelectionIframe';

export const ConversionBarContainer = (props: ConversionBarComponentProps) => {
    const isTicketSelectionAvailableInListings = checkGate(
        'listings_client_ticket_selection',
    );

    if (!isStatsigInitialized()) {
        return null;
    }

    return (
        <div className="conversion-bar eds-fx--slide-up">
            {isTicketSelectionAvailableInListings ? (
                <TicketSelectionIframe id={props.id} />
            ) : (
                <ConversionBar {...props} />
            )}
        </div>
    );
};
